import { render, staticRenderFns } from "./AtlasMenu.vue?vue&type=template&id=290d5483&scoped=true&"
import script from "./AtlasMenu.vue?vue&type=script&lang=js&"
export * from "./AtlasMenu.vue?vue&type=script&lang=js&"
import style0 from "./AtlasMenu.vue?vue&type=style&index=0&id=290d5483&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290d5483",
  null
  
)

export default component.exports